import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import type { OnboardingSummary } from "../../../zodios/apiDefinitions/api/onboardingSummary";

export const ONBOARDING_SUMMARY_QUERY_KEY = ["onboarding-summary"];

export const useOnboardingSummary = <TData = OnboardingSummary>(
  options?: Omit<UseQueryOptions<OnboardingSummary, Error, TData>, "queryKey" | "queryFn">,
) => {
  return useQuery({
    queryKey: ONBOARDING_SUMMARY_QUERY_KEY,
    queryFn: async () => await apiClient.getOnboardingSummary(),
    ...options,
  });
};
